import { default as RedirectRoute } from './RedirectRoute';

export default RedirectRoute;
